export default __webpack_public_path__ + "static/media/b1.475619ca.jpg";